import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

export const CustomToolTip = styled(Tooltip)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "100%",
    zIndex: "99999 !important",
  },
});